import React, {useState} from "react";
import Slider from "react-slick";
import "./HistoryEventsHP.css";
import moment from 'moment';
import 'moment/locale/he';
import HistoryEventsSlider from './HistoryEventsSlider';

const HistoryEventsHP = function (props) {
    //console.log(props.data);
    let historyEventsDisplayHP = props.data.filter(event => {return (moment(event.MuseumHistoryEventDate).format('M')==(moment().format("M")))}).filter(event => {return event.MuseumHistoryEventHP=='כן'});
    let historyEvntsHPCounter = historyEventsDisplayHP.length>4 ? 4 : historyEventsDisplayHP.length;
    return (
        <React.Fragment>  
            <div className="container">
                <div className="historyEventstitleAndLink">
                    <div className="historyEventstitleContainer">
                        <h3 className="historyEventsMainTitle">אירועי החודש לפני...</h3>
                    </div>
                    <div className="historyEventsLinkContainer">
                        <a href={props.allEventsLink} className="allHistoryEventsLink" title="לכל האירועים" >לכל האירועים</a>
                    </div>
                </div>

                <div className="allHistoryEvents">
                    <HistoryEventsSlider allEventsLink={props.allEventsLink} data={historyEventsDisplayHP} historyEventsDisplayCounter={historyEvntsHPCounter} HPorP={1}/>
                </div>
            </div>
        </React.Fragment>

    );}



export default HistoryEventsHP;
